import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

import { SET_DATA_ACNHOR } from "constants/actions";
// Import your custom dropdown component instead of semantic-ui's Select
import SelectBox from "new_components/molecules/SelectBox";
import { filterStaplesOptions } from "utilities/organizationUtils";

const Anchor = (props) => {
  const dispatch = useDispatch();
  const core_data = useSelector((state) => state.audit.core_data, shallowEqual);
  const get_employee_permission = useSelector(
    (state) => state.employee_permission,
    shallowEqual
  );

  const get_auth = useSelector(
    (state) => state.auth,
    shallowEqual
  );

  const { onSelect, selectedAnchor } = props;
  // Build options using "label" instead of "text"
  const build_state = (is_french) => {
    const employeeId = get_auth?.employee_id;
    const permissionInfo = {
      permissionRecords: get_employee_permission?.employee_permission,
      employeeId,
      employee: { account_type: get_auth?.account_type },
    };

    let _state = filterStaplesOptions(core_data?.categories[0]?.categories, permissionInfo)
      ?.filter((f) => f.priority.toLowerCase() !== "primary")
      ?.map((i) => ({
        label: is_french ? (i.fr_name ? i.fr_name : i.name) : i.name,
        value: i.id,
      }));
    if (!props.pdf && _state) {
      const primaryCategory = filterStaplesOptions(core_data?.categories?.[0]?.categories, permissionInfo)
        ?.find((f) => f.priority.toLowerCase() === "primary");
      if (primaryCategory) {
        _state.unshift({
          value: primaryCategory.id,
          label: is_french ? "Aperçu" : "Overview",
        });
      }
    }
    return _state;
  };

  const [selected, setSelected] = useState(props.selectedAnchor || null);
  const [anchor_list, set_anchor_list] = useState();
  const [userSelected, setUserSelected] = useState(props.selectedAnchor || null);

  useEffect(() => {
    if (!selected && core_data?.categories?.[0] && userSelected) {
      const primaryCategory = core_data?.categories?.[0]?.categories?.find(
        (f) => f.priority === "primary"
      );
      if (primaryCategory) {
        setSelected(primaryCategory.id);
      }
    }
  }, [selected, core_data?.categories, userSelected]);

  useEffect(() => {
    if (get_employee_permission) {
      if (
        get_employee_permission.employee_permission?.[0]?.details?.[0]?.name_id
      ) {
        setSelected(
          get_employee_permission.employee_permission?.[0].details[0].name_id
        );
      }
    }
  }, [get_employee_permission]);

  useEffect(() => {
    if (props.pdf && anchor_list && userSelected) {
      const selectedValue = anchor_list.find(
        (anchor) => anchor.label === "Roles"
      );
      setSelected(
        (selectedValue && selectedValue?.value) || anchor_list?.[0]?.value
      );
    }
  }, [anchor_list, userSelected]);

  useEffect(() => {
    if (!anchor_list) {
      set_anchor_list(build_state(props.is_french));
    }
  }, [props]);

  // Handle selectedAnchor prop - pre-select if provided
  useEffect(() => {
    if (props.selectedAnchor && anchor_list) {
      // Find the anchor with matching ID
      const matchingAnchor = anchor_list.find(anchor => anchor.value === props.selectedAnchor);
      if (matchingAnchor) {
        setSelected(props.selectedAnchor);
        setUserSelected(props.selectedAnchor);
      }
    }
  }, [props.selectedAnchor, anchor_list]);

  useEffect(() => {
    dispatch({
      type: SET_DATA_ACNHOR,
      payload: selected || props.selectedAnchor,
    });
  }, [dispatch, selected, props.selectedAnchor]);

  return (
    <div className="anchors">
      <SelectBox
        label="Anchor" // You can update the label as needed
        options={anchor_list || []}
        value={userSelected}
        placeholder="Select an Anchor"
        onSelect={(value) => {
          setSelected(value);
          setUserSelected(value);
          onSelect(value);
        }}
        width="250px" // Adjust width as needed
      />
    </div>
  );
};

export default Anchor;
